// extracted by mini-css-extract-plugin
export default {"root":"Popover_root__vbE58"};